module.exports = __webpack_public_path__ + "static/media/unsplash_1-aA2Fadydc.5a98d89d.jpg";